import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { ReturnDocumentsLoadFlag } from "@app/models/flagLoadDocuments.model";
import { UploadDocumentsService } from "@app/services/upload-documents.service";
import { ActivatedRoute } from "@angular/router";
import { ModalService } from "@services/modal.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { environment } from 'src/environments/environment';

interface FileData {
  id?: any;
  source?: string;
  user?: string;
  documentType?: any;
  document?: any;
  originalName?: string;
  creationDate?: any;
  category?: string;
  infoFile?: string;
  originalPath?: any;
  originalFinalName?: any;
  resourceId?: any;
}
@Component({
  selector: "app-modal-upload-mail-file",
  templateUrl: "./modal-upload-mail-file.component.html",
  styleUrls: ["./modal-upload-mail-file.component.scss"],
})
export class ModalUploadMailFileComponent {

  public dataFileList = [];
  public fileData: FileData;
  public idRecurso: string | null;
  public numberDoc: string;
  public numEntero: number;
  public promiseList = [];
  public count = 0;
  public opc = 0;
  public uploadedDocs = 0;
  public urlCF: string;

  @Input() enableButton: boolean = false;
  @Output() close: EventEmitter<File[]> = new EventEmitter();
  @Output() confirm: EventEmitter<object> = new EventEmitter();
  @Output() numberDocuments: EventEmitter<number> = new EventEmitter();
  @Output() removeFileEvent: EventEmitter<number> = new EventEmitter();

  constructor(
    public modalService: ModalService,
    private route: ActivatedRoute,
    public spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private uploadDocumentsService: UploadDocumentsService,
  ) {
    this.urlCF = environment.covifacturaLandingUrl;
  }

  objFileTypes = [
    {
      name: "Declaración de renta último año fiscal",
      number: 0,
    },
    {
      name: "Estados financieros del último periodo",
      number: 1,
    },
    {
      name: "Estados financieros de los últimos 2 años",
      number: 2,
    },
  ];

  ngOnInit(): void {
    this.idRecurso = this.route.snapshot.paramMap.get("idRecurso");
    this.numberDoc = this.route.snapshot.paramMap.get("numberDoc");
    this.numEntero = parseInt(this.numberDoc);
  }

  createArrayFile(objectFile: any, idx: number) {
    this.uploadedDocs += 1;
    this.promiseList[idx] = this.toBase64(objectFile.params);
    this.dataFileList[idx] = objectFile.params;
    this.uploadedFile(idx);

    if (this.uploadedDocs == this.numEntero) {
      this.enableButton = true;
    }
  }

  async toBase64(file: File) {
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
    return base64;
  }

  uploadedFile(idx) {
    this.numberDocuments.emit(idx);
  }

  onRemove(event, idx) {
    this.removeFileEvent.emit(idx);
    this.enableButton = false;
    let position = this.promiseList.indexOf(event);
    if (this.promiseList.length === 0) return;
    else {
      if (position == -1) {
        this.promiseList.splice(idx, 1, '');
        this.dataFileList.splice(idx, 1, '');
      } else {
        this.promiseList.splice(position, idx, '');
        this.dataFileList.splice(position, idx, '');
      }
    }
    this.uploadedDocs -= 1;
  }

  verifyDocumentsUpload(): void {
    this.uploadDocumentsService.checkLoad(this.idRecurso).subscribe({
      complete: () => {
        this.sendInfo();
      },
      error: (err) => {
        this.toastr.error(err.error.message, "", {
          timeOut: 3000,
        });
        setTimeout(() => {
          window.location.reload();   
        }, 3000);
      },
    });
  }

  async sendInfo(event?): Promise<void> {
    this.spinner.show();
    if (this.promiseList.length === 0) return;
    else {
      if (this.opc === 0) {
        this.uploadDocumentsService.sendInfoUser(this.idRecurso).subscribe({
          next: (response: any) => {
            Promise.all(this.promiseList).then((filesBase64) => {
              filesBase64.forEach((file, index) => {
                this.fileData = {
                  id: null,
                  source: "CovifacturaWeb",
                  documentType: response.data.tipoDocComprador,
                  document: response.data.documentoComprador,
                  originalPath: null,
                  originalFinalName: this.dataFileList[index].name,
                  resourceId: this.idRecurso,
                  user: response.data.nombreComprador,
                  infoFile: file.split(",")[1],
                  category: "SOLICITUD CUPO",
                  originalName: this.dataFileList[index].name.split(".")[0],
                }

                this.uploadDocumentsService.sendDocuments(this.fileData).subscribe({
                  next: () => { },
                  complete: () => {
                    this.count = this.count + 1;

                    if (Number(this.numberDoc) == this.count) {
                      this.sendUploadDocumentsFlag();
                    }
                  },
                  error: (err) => {
                    this.spinner.hide();
                    this.toastr.error(err.error.message, "", {
                      timeOut: 4000,
                    });
                  },
                });
              })
            });
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error(err.error.message, "", {
              timeOut: 3000,
            });
          },
        });
      } else if (this.opc == 1) {
        this.opc = 2;
      }
    }
  }

  sendUploadDocumentsFlag() {
    const flagBody = {
      radicado: this.idRecurso,
      numeroDocumentos: this.numEntero,
    };

    this.uploadDocumentsService.saveDocumentUploadFlag(flagBody).subscribe({
      next: (response: ReturnDocumentsLoadFlag) => {
        console.log(response);
      },
      complete: () => {
        this.spinner.hide();
        this.opc = 1;
      },
      error: (err) => {
        this.spinner.hide();
        console.error(err);
      },
    });
  }

  accept() {
    this.confirm.emit();
    this.close.emit();
    window.location.reload();
  }

  ngOnDestroy() {
    this.modalService.close();
  }
}